import { render, staticRenderFns } from "./HisAssets.vue?vue&type=template&id=b198fb8c&scoped=true"
import script from "./HisAssets.vue?vue&type=script&lang=js"
export * from "./HisAssets.vue?vue&type=script&lang=js"
import style0 from "./HisAssets.vue?vue&type=style&index=0&id=b198fb8c&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b198fb8c",
  null
  
)

export default component.exports